import { Component, Inject, InjectionToken } from '@angular/core';

export const FiAppearanceWidgetSettingsParent = new InjectionToken('FiAppearanceWidgetSettingsParent');

@Component({
    selector: 'fi-appearance-widget-settings',
    templateUrl: './widget-settings.component.html',
    standalone: false,
})
export class FiAppearanceWidgetSettingsComponent {
    constructor(@Inject(FiAppearanceWidgetSettingsParent) public parent) {}
}
